import React from 'react';
import { Elements } from 'react-stripe-elements';
import PropTypes from 'prop-types';

import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import DesktopGrid from '../../components/DesktopGrid';
import PaymentForm from '../../components/PaymentForm';
import If from '../../shared/If';
import { CenteredSpinner } from '../../shared/Spinner';

import styles from './styles.sass';

class AdAdvertiserCreatePaymentScreen extends React.Component {
  componentDidMount() {
    const { onComponentDidMount } = this.props;
    onComponentDidMount();
  }

  render = () => {
    const {
      advertiserName,
      isFetching,
      isPaymentSuccessful,
      onSubmitPaymentForm,
    } = this.props;
    return (
      <Elements>
        <div className={styles.root}>
          <DesktopGrid fillHeight>
            <If
              condition={isFetching}
              ifRender={<CenteredSpinner color="gray" />}
              elseRender={
                <React.Fragment>
                  <h1 className="text-center">{advertiserName}</h1>
                  <Row>
                    <Col xs={12} sm={8} lg={6} smOffset={2} lgOffset={3}>
                      {advertiserName && (
                        <If
                          condition={isPaymentSuccessful}
                          ifRender={
                            <p className="text-center">
                              <strong>Thanks!</strong>
                            </p>
                          }
                          elseRender={
                            <PaymentForm
                              className={styles.paymentForm}
                              creditCardLinkClassName={
                                styles.payWithCreditCardLink
                              }
                              selectedProduct={{ amount: 0 }}
                              itemLabel="Anchor Sponsorships"
                              totalLabel="Fund Ads on Anchor"
                              onSubmitPaymentForm={onSubmitPaymentForm}
                            />
                          }
                        />
                      )}
                    </Col>
                  </Row>
                </React.Fragment>
              }
            />
          </DesktopGrid>
        </div>
      </Elements>
    );
  };
}

AdAdvertiserCreatePaymentScreen.defaultProps = {};

AdAdvertiserCreatePaymentScreen.propTypes = {
  advertiserName: PropTypes.string,
};

export { AdAdvertiserCreatePaymentScreen as default };
